import { useState } from 'react'
import { useArtworks } from '../hooks/useArtworks'
import { ArtworkStatus } from '@/types/entities'
import { ArtworkTable } from './ArtworkTable'
import { EmptyState } from '@/components/common/data-display/EmptyState'
import { LoadingSpinner } from '@/components/common/feedback/LoadingSpinner'
import { PAGINATION } from '@/config/constants'

export function PublishedArtworksList() {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState<number>(PAGINATION.DEFAULT_PAGE_SIZE)

  const { data, isLoading } = useArtworks(ArtworkStatus.PUBLISHED, {
    start: (page - 1) * pageSize,
    limit: pageSize,
  })

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!data || data.data.length === 0) {
    return <EmptyState title="No published artworks" description="No artworks have been published yet" />
  }

  return (
    <ArtworkTable
      artworks={data.data}
      page={page}
      pageSize={pageSize}
      total={data.total}
      onPageChange={setPage}
      onPageSizeChange={setPageSize}
    />
  )
}

